import { computed } from 'vue';
import { useTheme } from 'vuetify';

import { useAppCookies } from './useCookies';

export function useAppTheme() {
  const theme = useTheme();
  const { getCookies, setCookies } = useAppCookies();

  // Initialize theme from cookie
  const userPreferences = getCookies('userPreferences');
  if (userPreferences?.theme) {
    theme.change(userPreferences.theme);
  }

  const dark = computed(() => {
    return theme.global.current.value.dark;
  });

  const toggleTheme = () => {
    const userPreferences = getCookies('userPreferences') ?? {};
    const newTheme = dark.value ? 'light' : 'dark';
    userPreferences.theme = newTheme;
    theme.change(newTheme);
    setCookies('userPreferences', userPreferences);
  };

  return { theme, dark, toggleTheme };
}
